// extracted by mini-css-extract-plugin
module.exports = {"title":"bullet-list-block_title__UyYkM"};